import React from 'react';
import type { PassportVisual } from '@bilt/domain/passportVisual';
import type { PassportCard } from '../../services/api/passportCards';
export default function PassportVisualLayers({
  card,
  face,
  asset,
}: {
  card: PassportCard;
  face: 'front' | 'back';
  asset: (id: string, materialMask?: boolean) => React.ReactNode;
}) {
  const v = card.design.visual;
  if (!v || v.schema_version !== 1 || !card.subject) return null;
  return (
    <div className="pe-visual-layers" aria-label="Published artwork">
      {[...v.faces[face]]
        .sort((a, b) => a.z - b.z)
        .map((l) => {
          const bound = l.binding ? card.subject?.facts?.[l.binding] : undefined;
          if (
            l.visibility === 'when_bound' &&
            (bound === undefined || bound === null || bound === '')
          )
            return null;
          const content = l.binding ? bound : l.text;
          return (
            <div
              key={l.id}
              className={`pe-layer pe-layer-${l.kind} pe-text-${l.style} pe-mask-${l.mask}`}
              style={
                {
                  left: `${l.x * 100}%`,
                  top: `${l.y * 100}%`,
                  width: `${l.width * 100}%`,
                  height: `${l.height * 100}%`,
                  zIndex: l.z,
                  opacity: l.opacity,
                  textAlign: l.align,
                  fontFamily:l.typography?(l.typography.font==='display'?'Outfit, sans-serif':'Work Sans, sans-serif'):undefined,
                  fontSize:l.typography?`${l.typography.size/280*100}cqw`:undefined,
                  fontWeight:l.typography?.weight,
                  color:l.typography?({paper:'#f4f3f0',ink:'#202225',accent:'#ff9750'}[l.typography.color]):undefined,
                  mixBlendMode: l.blend,
                  '--pe-crop': `${l.crop}%`,
                } as React.CSSProperties
              }
            >
              {l.asset_ref ? asset(l.asset_ref, l.kind === 'material_mask') : content}
            </div>
          );
        })}
    </div>
  );
}
export function visualMaterialStyle(
  v: PassportVisual | undefined
): React.CSSProperties | undefined {
  return v
    ? ({
        '--pe-shine': v.material.shine,
        '--pe-strength': v.material.strength,
        '--pe-direction': `${v.material.direction}deg`,
        '--pe-width': `${v.material.width * 100}%`,
        '--pe-duration': `${v.material.duration_ms}ms`,
      } as React.CSSProperties)
    : undefined;
}
